/**
 * Do not edit directly, this file was auto-generated.
 */

import { Color } from "./color.js";

export const swatches = {
  odinLight0: new Color(255, 255, 255, 1),
  odinLight100: new Color(251, 251, 251, 1),
  odinLight200: new Color(248, 248, 248, 1),
  odinLight300: new Color(240, 240, 240, 1),
  odinLight400: new Color(233, 233, 233, 1),
  odinLight500: new Color(226, 226, 226, 1),
  odinLight600: new Color(219, 219, 219, 1),
  odinLight700: new Color(212, 212, 212, 1),
  odinLight1000: new Color(28, 28, 28, 1),
  odinLight2000: new Color(37, 37, 37, 1),
  odinDark0: new Color(0, 0, 0, 1),
  odinDark50: new Color(15, 18, 21, 1),
  odinDark100: new Color(21, 25, 29, 1),
  odinDark200: new Color(26, 30, 33, 1),
  odinDark300: new Color(32, 36, 39, 1),
  odinDark400: new Color(38, 42, 45, 1),
  odinDark500: new Color(44, 48, 51, 1),
  odinDark600: new Color(50, 54, 57, 1),
  odinDark700: new Color(56, 60, 63, 1),
  odinDark1000: new Color(218, 223, 227, 1),
  ifritLight50: new Color(252, 241, 241, 1),
  ifritLight100: new Color(253, 210, 211, 1),
  ifritLight200: new Color(255, 171, 174, 1),
  ifritLight300: new Color(253, 132, 141, 1),
  ifritLight400: new Color(244, 103, 118, 1),
  ifritLight500: new Color(205, 73, 90, 1),
  ifritLight600: new Color(162, 53, 68, 1),
  ifritLight700: new Color(121, 43, 52, 1),
  ifritLight800: new Color(82, 32, 36, 1),
  ifritLight900: new Color(51, 15, 19, 1),
  ifritDark50: new Color(255, 242, 242, 1),
  ifritDark100: new Color(254, 206, 207, 1),
  ifritDark200: new Color(247, 171, 173, 1),
  ifritDark300: new Color(231, 132, 138, 1),
  ifritDark400: new Color(220, 105, 115, 1),
  ifritDark500: new Color(195, 74, 88, 1),
  ifritDark600: new Color(166, 49, 67, 1),
  ifritDark700: new Color(121, 43, 52, 1),
  ifritDark800: new Color(92, 20, 32, 1),
  ifritDark900: new Color(51, 15, 19, 1),
  phoenixLight50: new Color(255, 237, 229, 1),
  phoenixLight100: new Color(255, 213, 193, 1),
  phoenixLight200: new Color(255, 176, 139, 1),
  phoenixLight300: new Color(255, 135, 78, 1),
  phoenixLight400: new Color(235, 112, 53, 1),
  phoenixLight500: new Color(191, 84, 33, 1),
  phoenixLight600: new Color(151, 67, 26, 1),
  phoenixLight700: new Color(113, 52, 23, 1),
  phoenixLight800: new Color(75, 38, 20, 1),
  phoenixLight900: new Color(40, 23, 14, 1),
  phoenixDark50: new Color(255, 242, 237, 1),
  phoenixDark100: new Color(252, 208, 188, 1),
  phoenixDark200: new Color(245, 174, 141, 1),
  phoenixDark300: new Color(226, 138, 96, 1),
  phoenixDark400: new Color(213, 113, 65, 1),
  phoenixDark500: new Color(186, 85, 37, 1),
  phoenixDark600: new Color(154, 61, 16, 1),
  phoenixDark700: new Color(113, 52, 23, 1),
  phoenixDark800: new Color(82, 33, 9, 1),
  phoenixDark900: new Color(40, 23, 14, 1),
  titanLight50: new Color(255, 239, 222, 1),
  titanLight100: new Color(252, 214, 166, 1),
  titanLight200: new Color(248, 184, 91, 1),
  titanLight300: new Color(227, 155, 34, 1),
  titanLight400: new Color(197, 131, 0, 1),
  titanLight500: new Color(163, 108, 3, 1),
  titanLight600: new Color(130, 85, 3, 1),
  titanLight700: new Color(98, 63, 2, 1),
  titanLight800: new Color(66, 43, 6, 1),
  titanLight900: new Color(37, 25, 5, 1),
  titanDark50: new Color(255, 243, 229, 1),
  titanDark100: new Color(247, 211, 166, 1),
  titanDark200: new Color(234, 181, 108, 1),
  titanDark300: new Color(209, 149, 58, 1),
  titanDark400: new Color(188, 129, 30, 1),
  titanDark500: new Color(160, 106, 7, 1),
  titanDark600: new Color(124, 82, 9, 1),
  titanDark700: new Color(98, 63, 2, 1),
  titanDark800: new Color(62, 45, 21, 1),
  titanDark900: new Color(35, 26, 11, 1),
  sylphLight50: new Color(240, 242, 219, 1),
  sylphLight100: new Color(218, 228, 156, 1),
  sylphLight200: new Color(184, 201, 94, 1),
  sylphLight300: new Color(157, 177, 56, 1),
  sylphLight400: new Color(130, 150, 29, 1),
  sylphLight500: new Color(107, 125, 13, 1),
  sylphLight600: new Color(83, 99, 0, 1),
  sylphLight700: new Color(63, 74, 5, 1),
  sylphLight800: new Color(44, 50, 8, 1),
  sylphLight900: new Color(27, 29, 8, 1),
  sylphDark50: new Color(244, 247, 218, 1),
  sylphDark100: new Color(216, 222, 169, 1),
  sylphDark200: new Color(187, 197, 125, 1),
  sylphDark300: new Color(155, 168, 80, 1),
  sylphDark400: new Color(133, 149, 49, 1),
  sylphDark500: new Color(106, 124, 8, 1),
  sylphDark600: new Color(82, 98, 0, 1),
  sylphDark700: new Color(62, 74, 0, 1),
  sylphDark800: new Color(44, 52, 0, 1),
  sylphDark900: new Color(27, 29, 5, 1),
  garudaLight50: new Color(217, 247, 214, 1),
  garudaLight100: new Color(192, 235, 189, 1),
  garudaLight200: new Color(142, 216, 141, 1),
  garudaLight300: new Color(99, 191, 102, 1),
  garudaLight400: new Color(68, 170, 76, 1),
  garudaLight500: new Color(24, 136, 45, 1),
  garudaLight600: new Color(1, 107, 29, 1),
  garudaLight700: new Color(12, 82, 24, 1),
  garudaLight800: new Color(11, 56, 17, 1),
  garudaLight900: new Color(10, 32, 7, 1),
  garudaDark50: new Color(234, 249, 232, 1),
  garudaDark100: new Color(187, 229, 184, 1),
  garudaDark200: new Color(148, 205, 146, 1),
  garudaDark300: new Color(115, 181, 114, 1),
  garudaDark400: new Color(83, 158, 85, 1),
  garudaDark500: new Color(50, 132, 57, 1),
  garudaDark600: new Color(19, 106, 34, 1),
  garudaDark700: new Color(12, 82, 24, 1),
  garudaDark800: new Color(2, 57, 12, 1),
  garudaDark900: new Color(10, 32, 7, 1),
  shivaLight50: new Color(221, 246, 248, 1),
  shivaLight100: new Color(177, 234, 239, 1),
  shivaLight200: new Color(114, 211, 220, 1),
  shivaLight300: new Color(58, 187, 198, 1),
  shivaLight400: new Color(0, 161, 172, 1),
  shivaLight500: new Color(1, 131, 140, 1),
  shivaLight600: new Color(1, 106, 113, 1),
  shivaLight700: new Color(12, 79, 84, 1),
  shivaLight800: new Color(15, 54, 57, 1),
  shivaLight900: new Color(11, 40, 51, 1),
  shivaDark50: new Color(231, 242, 243, 1),
  shivaDark100: new Color(189, 217, 221, 1),
  shivaDark200: new Color(144, 191, 197, 1),
  shivaDark300: new Color(100, 166, 175, 1),
  shivaDark400: new Color(78, 153, 163, 1),
  shivaDark500: new Color(34, 128, 140, 1),
  shivaDark600: new Color(26, 99, 108, 1),
  shivaDark700: new Color(12, 79, 84, 1),
  shivaDark800: new Color(12, 50, 54, 1),
  shivaDark900: new Color(8, 29, 32, 1),
  shivaDark1000: new Color(11, 19, 22, 1),
  leviathanLight50: new Color(233, 242, 252, 1),
  leviathanLight100: new Color(188, 219, 250, 1),
  leviathanLight200: new Color(135, 196, 248, 1),
  leviathanLight300: new Color(87, 173, 236, 1),
  leviathanLight400: new Color(21, 149, 218, 1),
  leviathanLight500: new Color(0, 126, 187, 1),
  leviathanLight600: new Color(0, 100, 149, 1),
  leviathanLight700: new Color(0, 76, 115, 1),
  leviathanLight800: new Color(0, 52, 81, 1),
  leviathanLight900: new Color(6, 30, 46, 1),
  leviathanDark50: new Color(238, 244, 252, 1),
  leviathanDark100: new Color(198, 221, 247, 1),
  leviathanDark200: new Color(157, 195, 236, 1),
  leviathanDark300: new Color(119, 170, 220, 1),
  leviathanDark400: new Color(86, 145, 199, 1),
  leviathanDark500: new Color(55, 120, 172, 1),
  leviathanDark600: new Color(30, 96, 143, 1),
  leviathanDark700: new Color(0, 76, 115, 1),
  leviathanDark800: new Color(9, 51, 79, 1),
  leviathanDark900: new Color(9, 29, 46, 1),
  fenrirLight50: new Color(240, 240, 249, 1),
  fenrirLight100: new Color(209, 211, 252, 1),
  fenrirLight200: new Color(177, 184, 252, 1),
  fenrirLight300: new Color(142, 156, 246, 1),
  fenrirLight400: new Color(108, 130, 234, 1),
  fenrirLight500: new Color(74, 105, 212, 1),
  fenrirLight600: new Color(48, 83, 179, 1),
  fenrirLight700: new Color(31, 61, 140, 1),
  fenrirLight800: new Color(23, 42, 99, 1),
  fenrirLight900: new Color(17, 26, 59, 1),
  fenrirDark50: new Color(244, 244, 255, 1),
  fenrirDark100: new Color(214, 216, 253, 1),
  fenrirDark200: new Color(183, 188, 251, 1),
  fenrirDark300: new Color(147, 157, 239, 1),
  fenrirDark400: new Color(121, 137, 231, 1),
  fenrirDark500: new Color(89, 111, 208, 1),
  fenrirDark600: new Color(60, 87, 179, 1),
  fenrirDark700: new Color(31, 61, 140, 1),
  fenrirDark800: new Color(24, 45, 106, 1),
  fenrirDark900: new Color(15, 26, 62, 1),
  ramuhLight50: new Color(245, 238, 250, 1),
  ramuhLight100: new Color(230, 207, 247, 1),
  ramuhLight200: new Color(212, 175, 243, 1),
  ramuhLight300: new Color(193, 143, 237, 1),
  ramuhLight400: new Color(171, 112, 227, 1),
  ramuhLight500: new Color(147, 84, 211, 1),
  ramuhLight600: new Color(122, 58, 187, 1),
  ramuhLight700: new Color(95, 38, 154, 1),
  ramuhLight800: new Color(67, 22, 115, 1),
  ramuhLight900: new Color(41, 12, 70, 1),
  ramuhDark50: new Color(250, 243, 255, 1),
  ramuhDark100: new Color(229, 208, 245, 1),
  ramuhDark200: new Color(209, 172, 239, 1),
  ramuhDark300: new Color(190, 140, 233, 1),
  ramuhDark400: new Color(169, 110, 224, 1),
  ramuhDark500: new Color(145, 81, 209, 1),
  ramuhDark600: new Color(119, 55, 186, 1),
  ramuhDark700: new Color(95, 38, 154, 1),
  ramuhDark800: new Color(67, 25, 110, 1),
  ramuhDark900: new Color(40, 15, 65, 1),
  jenovaLight50: new Color(248, 238, 243, 1),
  jenovaLight100: new Color(255, 204, 233, 1),
  jenovaLight200: new Color(255, 164, 218, 1),
  jenovaLight300: new Color(244, 127, 200, 1),
  jenovaLight400: new Color(217, 88, 171, 1),
  jenovaLight500: new Color(194, 67, 151, 1),
  jenovaLight600: new Color(161, 44, 123, 1),
  jenovaLight700: new Color(125, 31, 94, 1),
  jenovaLight800: new Color(86, 23, 65, 1),
  jenovaLight900: new Color(48, 16, 36, 1),
  jenovaDark50: new Color(255, 241, 249, 1),
  jenovaDark100: new Color(250, 201, 228, 1),
  jenovaDark200: new Color(241, 163, 209, 1),
  jenovaDark300: new Color(227, 129, 188, 1),
  jenovaDark400: new Color(209, 99, 167, 1),
  jenovaDark500: new Color(185, 72, 145, 1),
  jenovaDark600: new Color(156, 48, 119, 1),
  jenovaDark700: new Color(125, 31, 94, 1),
  jenovaDark800: new Color(89, 19, 66, 1),
  jenovaDark900: new Color(51, 13, 37, 1),
};

export { Color } from "./color.js";
